import Vue from 'vue'
import Vuex from 'vuex'
import db from '@/firebase/init'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,
  state: {
    isLogged: false,
    isCategory: null, // valittu kategoria
    isCategoryMenu: true, // kategoriamenu: on/off
    popupContent: null,

    vuexCategories: [],
    vuexTopics: [],
    vuexMeans: [],
    vuexExamples: [],

    // LOPULLISET
    theCategories: [],
    theMeans: [],
    theExamples: [],
    feedbackContexts: ['palaute', 'kehitysehdotus', 'ongelma', 'muu'],
    ui: {
      footerHeight: 198 // default, jos käy niin ettei vuex ehdi päivittyä kun sivu ko. on jo latautunut
    },
    // db data
    topics: [],
    topicsUpdated: false,
    categories: [],
    categoriesUpdated: false,
    means: [],
    meansUpdated: false,
    examples: [],
    examplesUpdated: false

  },

  getters: {
    getterMeans (state) {
      return state.means
    },
    getterExamples (state) {
      return state.examples
    },
    topicSlugs (state) {
      let topics = state.topics
      let slugs = []
      topics.forEach(topic => {
        slugs.push(topic.slug)
      })
      return slugs
    },

    slugsOfTopics (state, getters) {
      let slugs = []
      state.topics.forEach(topic => {
        slugs.push(topic.slug)
      })
      return slugs
    },
    slugsOfMeans (state, getters) {
      let slugs = []
      state.means.forEach(mean => {
        slugs.push(mean.slug)
      })
      return slugs
    },
    slugsOfExamples (state, getters) {
      let slugs = []
      state.examples.forEach(example => {
        slugs.push(example.slug)
      })
      return slugs
    },
    fullWindowHeightMinusFooter (state, getters) {
      let footer = state.ui.footerHeight
      return `calc(100% - ${footer}px)`
    }
  },

  mutations: {
    storeTopics: (state, payload) => {
      state.topics = payload
      state.topicsUpdated = true
    },
    storeCategories: (state, payload) => {
      state.categories = payload
      state.categoriesUpdated = true
    },
    storeMeans: (state, payload) => {
      state.means = payload
      state.meansUpdated = true
    },
    storeExamples: (state, payload) => {
      state.examples = payload
      state.examplesUpdated = true
    },
    changeUpdateState: (state, what) => {
      state[what + 'Updated'] = false
    },

    setLoggedState: (state, payload) => {
      state.isLogged = payload
    },
    /* setExampleList: (state, payload) => {
      state.examplesList.push(payload)
    }, */
    setCategory: (state, payload) => {
      state.isCategory = payload
    },
    setCategoryMenu: (state, payload) => {
      state.isCategoryMenu = payload
    },
    setPopupContent: (state, payload) => {
      state.popupContent = payload
    },

    // UUDET
    storeVuexCategories: (state, payload) => {
      state.vuexCategories = payload
    },
    storeVuexTopics: (state, payload) => {
      state.vuexTopics = payload
    },
    storeVuexMeans: (state, payload) => {
      state.vuexMeans = payload
    },
    storeVuexExamples: (state, payload) => {
      state.vuexExamples = payload
    },

    // LOPULLISET
    storeTheCategories: (state, payload) => {
      state.theCategories.push(payload)
    },
    storeTheMeans: (state, payload) => {
      state.theMeans.push(payload)
    },
    storeTheExamples: (state, payload) => {
      state.theExamples.push(payload)
    },
    trackFooterHeight: (state, payload) => {
      state.ui.footerHeight = payload
    }
  },

  actions: {
    changeUpdateState: ({ commit }, what) => {
      commit('changeUpdateState', what)
    },
    storeTopics: (context) => {
      // console.log(context.state.topicsUpdated, 'äksön');
      let topics = []
      if (!context.state.topicsUpdated) {
        db.collection('aiheet').get()
          .then(snapshot => {
            snapshot.docs.forEach(doc => {
              let topic = doc.data()
              topic.id = doc.id
              topics.push(topic)
            })
            context.commit('storeTopics', topics)
          })
        // console.log(topics, 'actionn');
      }
    },
    storeCategories: (context) => {
      let categories = []
      if (!context.state.categoriesUpdated) {
        db.collection('kategoriat').get().then(snapshot => {
          snapshot.docs.forEach(doc => {
            let category = doc.data()
            category.id = doc.id
            categories.push(category)
          })
          context.commit('storeCategories', categories)
        })
        // console.log(categories)
      }
    },
    storeMeans: (context) => {
      let means = []
      if (!context.state.meansUpdated) {
        db.collection('keinot').get().then(snapshot => {
          snapshot.docs.forEach(doc => {
            let mean = doc.data()
            mean.id = doc.id
            means.push(mean)
          })
          context.commit('storeMeans', means)
        })
        // console.log(means);
      }
    },
    storeExamples: (context, payload) => {
      let examples = []
      if (!context.state.examplesUpdated) {
        db.collection('kohteet').get().then(snapshot => {
          snapshot.docs.forEach(doc => {
            let example = doc.data()
            example.id = doc.id
            examples.push(example)
          })
          context.commit('storeExamples', examples)
        })
      }
    },

    setLoggedState: (context, payload) => {
      context.commit('setLoggedState', payload)
    },
    /* setExampleList: (context, payload) => {
      context.commit('setExampleList', payload)
    }, */
    setCategory: (context, payload) => {
      context.commit('setCategory', payload)
    },
    setCategoryMenu: (context, payload) => {
      context.commit('setCategoryMenu', payload)
    },
    setPopupContent: (context, payload) => {
      context.commit('setPopupContent', payload)
    },

    storeVuexCategories: (context, payload) => {
      context.commit('storeVuexCategories', payload)
    },
    storeVuexTopics: (context, payload) => {
      context.commit('storeVuexTopics', payload)
    },
    storeVuexMeans: (context, payload) => {
      context.commit('storeVuexMeans', payload)
    },
    storeVuexExamples: (context, payload) => {
      context.commit('storeVuexExamples', payload)
    },

    // LOPULLISET
    getAllCategories: (context) => {
      if (context.state.theCategories) {
        db.collection('kategoriat').get().then(snapshot => {
          snapshot.docs.forEach(doc => {
            let category = doc.data()
            category.id = doc.id
            context.commit('storeTheCategories', category)
          })
        })
      }
    },
    getAllMeans: (context) => {
      if (context.state.theMeans) {
        db.collection('keinot').get().then(snapshot => {
          snapshot.docs.forEach(doc => {
            let mean = doc.data()
            mean.id = doc.id
            context.commit('storeTheMeans', mean)
          })
        })
      }
    },
    getAllExamples: (context) => {
      if (context.state.theExamples) {
        db.collection('kohteet').get().then(snapshot => {
          snapshot.docs.forEach(doc => {
            let example = doc.data()
            example.id = doc.id
            context.commit('storeTheExamples', example)
          })
        })
      }
    },
    trackFooterHeight: ({ commit }, payload) => {
      commit('trackFooterHeight', payload)
    }
  }
})
